import { lazy } from 'react';

/**
Maps the Monarch UI Component customId to the React component path in our repo
**/
const listOfMonarchComponents = {
  // Banner components
  smbLpBannerBasicCalloutEditable: lazy( () => import( '@monarch/Banner | Basic Callout - Editable' ) ),
  smbLpBannerCtaEditable: lazy( () => import( '@monarch/Banner | CTA - Editable' ) ),
  smbLpBannerListEditable: lazy( () => import( '@monarch/Banner | List - Editable' ) ),
  smbLpBannerServiceCheckSingleLineEditable: lazy( () => import( '@monarch/Banner | Service Check Single Line - Editable' ) ),
  smbLpBannerValueEditable: lazy(() => import('@monarch/Banner | Value - Editable')),

  // CTA Slot components
  smbLpCtaSlotDualCtasEditable: lazy( () => import( '@monarch/CTA Slot | Dual CTAs - Editable' ) ),

  // Empty component
  smbLpEmpty: lazy( () => import( '@monarch/Empty' ) ),

  // Hero components
  smbLpHeroAddressCheckEditable: lazy( () => import( '@monarch/Hero | Address Check - Editable' ) ),
  smbLpHeroProductCardsRedesignEditable: lazy( () => import( '@monarch/Hero | Product Cards Redesign - Editable' ) ),
  smbLpHeroImageEditable: lazy( () => import( '@monarch/Hero | Image - Editable' ) ),
  smbLpHeroSplitCarouselEditable: lazy( () => import( '@monarch/Hero | Split Carousel - Editable' ) ),
  smbLpHeroSlimEditable: lazy( () => import( '@monarch/Hero | Slim - Editable' ) ),

  // Section components
  smbLpSectionAwardsCalloutEditable: lazy( () => import( '@monarch/Section | Awards Callout - Editable' ) ),
  smbLpSectionColumnContentCarouselEditable: lazy( () => import( '@monarch/Section | Column Content Carousel - Editable' ) ),
  smbLpSectionProductCardsRedesignEditable: lazy( () => import( '@monarch/Section | Product Cards Redesign - Editable' ) ),
  smbLpSectionProductTabsetEditable: lazy( () => import( '@monarch/Section | Product Tabset - Editable' ) ),
  smbLpSectionSplitSectionEditable: lazy( () => import( '@monarch/Section | Split Section - Editable' ) ),
  smbLpSectionThumbCarouselEditable: lazy( () => import( '@monarch/Section | Thumb Carousel - Editable' ) ),
  smbLpSectionPlanFeaturesEditable: lazy( () => import( '@monarch/Section | Plan Features - Editable' ) ),
  smbLpSectionPlanAddonsEditable: lazy( () => import( '@monarch/Section | Plan AddOns - Editable' ) ),
  smbLpSectionSimpleImageColumnsEditable: lazy( () => import( '@monarch/Section | Simple Image Columns - Editable' ) ),

  // Sticky CTA components
  smbLpStickyCtaShopPlansEditable: lazy( () => import( '@monarch/Sticky CTA | Shop Plans - Editable' ) ),
  smbLpSectionNavigationEditable: lazy( () => import( '@monarch/Section | Navigation - Editable/Index' ) ),

  // Footer
  smbLpFooterLegalEditable: lazy( () => import( '@monarch/Footer Legal - Editable' ) ),
};

export default listOfMonarchComponents;
